module.exports = __webpack_public_path__ + "img/01d.a078e096.png";